import jumpButtonClasses from './_jump_button.module.scss';

export default class UaJumpButton extends HTMLElement {
  constructor() {
    super();
    this.currentPosition = 'bottom';
  }

  get template() {
    return `<button class="c-button-v3  c-button-v3--tertiary  c-button-v3--xs ${jumpButtonClasses['jump-btn']}" type="button">Jump to bottom</button>`;
  }

  connectedCallback() {
    this.targetSelector = this.getAttribute('target') || '[data-scroll-container]';
    this.container = this.closest(this.targetSelector);

    if (!this.container) {
      console.warn('<jump-scroll> should be in a [data-scroll-container] element');
      return;
    }

    this.innerHTML = this.template;
    this.button = this.querySelector('button');

    this.button.addEventListener('click', () => this.handleClick());
    this.container.addEventListener('scroll', () => this.updateButton());
    this.updateButton();
  }

  handleClick() {
    const toTop = this.currentPosition === 'top';

    this.container.scrollTo({
      top: toTop ? 0 : this.container.scrollHeight,
      behavior: 'smooth'
    });

    this.button.textContent = toTop ? 'Jump to Bottom' : 'Jump to Top';
    this.currentPosition = toTop ? 'bottom' : 'top';
  }

  updateButton() {
    const threshold = 20;
    const atTop = this.container.scrollTop < threshold;

    if (atTop) {
      this.button.textContent = 'Jump to Bottom';
      this.currentPosition = 'bottom';
    } else {
      this.button.textContent = 'Jump to Top';
      this.currentPosition = 'top';
    }
  }
}